import shares from './client';
const opts = {
    headers: {
        Accept: `application/vnd.newbay.cloud.share-1.1+json`,
        'Content-Type': `application/vnd.newbay.cloud.share-1.1+json`,
    },
};
const apiType = 'shares';
export const postShares = async (body, endpoint, headers, logger) => {
    logger ? shares.setLogger(logger) : undefined;
    return shares.post(`${endpoint}`, apiType, {
        data: body,
        headers: { ...opts.headers, ...headers },
    });
};
export const getShares = async (endpoint, headers, logger) => {
    logger ? shares.setLogger(logger) : undefined;
    return shares.get(`/shares${endpoint}`, apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
export const deleteShares = async (endpoint, headers, logger) => {
    logger ? shares.setLogger(logger) : undefined;
    return shares.delete(`${endpoint}`, apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
